import React from "react";
import Vupop from "../assets/Vupop.png";
import Arrow from "../assets/arrow.svg";
import vupop from "../assets/logo.webp";
import vupopCircular from "../assets/vupopCircular.png";
import { useNavigate } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="w-full bg-black px-8 sm:px-3 py-10">
        {/* Container */}
        <div className="relative w-full rounded-2xl overflow-hidden bg-[#111315] px-16 xl:px-12 lg:px-8 md:px-6 sm:px-4 py-14 md:py-10 sm:py-8 flex items-center justify-between md:flex-col md:gap-10">
          {/* LEFT CONTENT */}
          <div className="max-w-[620px] xl:max-w-[500px] lg:max-w-[440px] md:max-w-full text-left md:text-center">
            <p
              className="text-white text-[18px] xl:text-[15px] lg:text-[14px] sm:text-[13px] tracking-wide mb-3"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Be Part of the Revolution
            </p>

            <h2
              className="text-white font-extrabold text-[52px] xl:text-[42px] lg:text-[34px] md:text-[30px] sm:text-[26px] leading-tight mb-5"
              style={{ fontFamily: "'Norwester', sans-serif" }}
            >
              JOIN US NOW
            </h2>

            <p
              className="text-gray-400 text-[18px] xl:text-[15px] lg:text-[14px] md:text-[13px] sm:text-[13px] leading-relaxed mb-8 max-w-[540px] lg:max-w-full md:max-w-full"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Take the first step towards transforming how sports stories are
              told and experienced. Join Socials today, and contribute to a
              community that values authenticity and rewards fans for their
              social content
            </p>

            {/* Buttons */}
            <div className="flex gap-4 md:justify-center sm:flex-col sm:gap-3 w-full max-w-md md:max-w-full">
              <a
                href="https://manager.vupop.io/broadcaster/signup/subscription"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full"
              >
                <button
                  className="w-full bg-[#FFF528] hover:bg-[#FFF528]/70 transition-colors text-black text-[16px] xl:text-[14px] lg:text-[13px] sm:text-[13px] px-6 py-3 sm:py-2.5 rounded-md tracking-wide hover:opacity-90  duration-300"
                  style={{ fontFamily: "'Norwester', sans-serif" }}
                >
                  For Broadcasters
                </button>
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full"
              >
                <button
                  className="w-full bg-white text-black text-[16px] xl:text-[14px] lg:text-[13px] sm:text-[13px] px-6 py-3 sm:py-2.5 rounded-md tracking-wide hover:bg-gray-300 transition duration-300"
                  style={{ fontFamily: "'Norwester', sans-serif" }}
                >
                  For Fans
                </button>
              </a>
            </div>
          </div>

          {/* RIGHT SIDE IMAGE */}
          <div className="flex justify-center items-center w-[480px] xl:w-[400px] lg:w-[340px] md:w-full sm:w-full overflow-hidden rounded-full">
            <img
              src={vupopCircular}
              alt="Vupop Circular"
              className="w-full h-full max-w-[480px] xl:max-w-[400px] lg:max-w-[340px] md:max-w-[320px] sm:max-w-[260px] object-cover scale-150"
            />
          </div>
        </div>
      </section>
      <div className="w-full overflow-hidden mt-6 px-6 sm:px-4 relative">
        {/* Image */}
        <img src={Vupop} alt="Logo" className="object-cover w-full h-auto" />

        {/* Bottom Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent pointer-events-none"></div>
      </div>

      <div
        className="px-9 sm:px-6 py-10
     
      flex justify-between items-center
      pt-10 pb-10 p-3 
      xl:flex-row lg:flex-row md:flex-row sm:flex-row   sm:gap-6 mt-8
    "
      >
        <a
          onClick={(e) => {
            e.preventDefault();
            navigate("/ContactUs");
          }}
          className="
        text-[#F8FD24] underline cursor-pointer flex items-center
        text-5xl       
        xl:text-4xl    
        lg:text-4xl    
        md:text-4xl     
        sm:text-3xl     
        tracking-wide
      "
          style={{ fontFamily: "Norwester" }}
        >
          Contact Us
        </a>

        <img
          src={Arrow}
          alt="arrow"
          onClick={(e) => {
            e.preventDefault();
            navigate("/ContactUs");
          }}
          className="
    bg-[#F8FD24] 
    rounded-full 
    cursor-pointer 
    hover:opacity-90 
    transition-all 
    w-[80px] h-[80px] p-6    
    xl:w-[60px] xl:h-[60px] xl:p-4
    lg:w-[60px] lg:h-[60px] lg:p-4
    md:w-[55px] md:h-[55px] md:p-3
    sm:w-[45px] sm:h-[45px] sm:p-2
      "
        />
      </div>

      <footer className="w-full bg-black text-white">
        {/* Top Divider */}
        <div className="border-t border-white/10 mx-8 sm:mx-4"></div>

        {/* Main Content */}
        <div
          className="w-full px-9 sm:px-6 py-16 lg:py-12 md:py-10 sm:py-8
  flex items-start justify-between md:flex-col md:gap-10"
        >
          {/* LEFT COLUMN */}
          <div className="w-[38%] lg:w-[40%] md:w-full sm:w-full flex-shrink-0">
            <div>
              <img
                src={vupop}
                alt="Logo"
                className="h-16 xl:h-14 lg:h-12 sm:h-10 w-auto"
              />
            </div>

            <p
              className="uppercase text-[15px] xl:text-[13px] lg:text-[12px] sm:text-[12px] tracking-wider text-white mt-4 mb-8 sm:mb-6"
              style={{ fontFamily: "Norwester" }}
            >
              Real fans. Real moments. Real emotion.
            </p>

            {/* Store Buttons */}
            <div className="flex gap-4 sm:flex-col sm:w-full">
              {/* Google Play */}
              <a
                href="https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
                className="sm:w-full"
              >
                <div
                  className="bg-[#1A1D21] hover:bg-[#22262b] hover:border-white/20 border border-transparent transition-all
          rounded-lg px-5 py-3 flex items-center gap-3 cursor-pointer w-[180px] lg:w-[160px] sm:w-full"
                >
                  <svg
                    className="w-8 h-8 lg:w-7 lg:h-7 sm:w-6 sm:h-6 flex-shrink-0"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5Z"
                      fill="#00A0FF"
                    />
                    <path
                      d="M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z"
                      fill="#FF3E4C"
                    />
                    <path
                      d="M3.84 2.15C4.25 1.93 4.73 1.94 5.13 2.15L16.81 8.88L14.54 11.15L3.84 2.15Z"
                      fill="#00D856"
                    />
                    <path
                      d="M16.81 8.88L20.16 10.75C21.23 11.35 21.23 12.64 20.16 13.25L16.81 15.12L14.54 12.85L16.81 8.88Z"
                      fill="#FFCE00"
                    />
                  </svg>
                  <div className="leading-tight">
                    <p
                      className="text-[10px] lg:text-[9px] text-gray-400"
                      style={{ fontFamily: "Inter" }}
                    >
                      GET IT ON
                    </p>
                    <p className="text-[14px] lg:text-[13px] sm:text-[13px] font-semibold">
                      Google Play
                    </p>
                  </div>
                </div>
              </a>

              {/* App Store */}
              <a
                href="https://apps.apple.com/app/vupop/id6747295116"
                target="_blank"
                rel="noopener noreferrer"
                className="sm:w-full"
              >
                <div
                  className="bg-[#1A1D21] hover:bg-[#22262b] hover:border-white/20 border border-transparent transition-all
          rounded-lg px-5 py-3 flex items-center gap-3 cursor-pointer w-[180px] lg:w-[160px] sm:w-full"
                >
                  <svg
                    className="w-8 h-8 lg:w-7 lg:h-7 sm:w-6 sm:h-6 flex-shrink-0"
                    viewBox="0 0 24 24"
                    fill="white"
                  >
                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                  </svg>
                  <div className="leading-tight">
                    <p
                      className="text-[10px] lg:text-[9px] text-gray-400"
                      style={{ fontFamily: "Inter" }}
                    >
                      Download on the
                    </p>
                    <p className="text-[14px] lg:text-[13px] sm:text-[13px] font-semibold">
                      App Store
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>

          {/* RIGHT SECTION — Solutions + Company */}
          <div
            className="flex items-start gap-24 lg:gap-16 md:gap-12 sm:gap-8 md:flex-row sm:flex-row"
            style={{ fontFamily: "Inter" }}
          >
            {/* Solutions Column */}
            <div className="min-w-[160px] lg:min-w-[140px] sm:min-w-0">
              <h4 className="text-white text-[16px] xl:text-[15px] lg:text-[14px] sm:text-[13px] font-semibold mb-6 sm:mb-4">
                Solutions
              </h4>
              <ul className="space-y-4 sm:space-y-3 text-gray-400 text-[15px] xl:text-[14px] lg:text-[13px] sm:text-[12px]">
                <li className="hover:text-white hover:translate-x-1 transition-all cursor-pointer">
                  <a href="/VupopForFans" className="block">
                    Vupop for Fans
                  </a>
                </li>
                <li className="hover:text-white hover:translate-x-1 transition-all cursor-pointer">
                  <a href="/VupopForBroadcasters" className="block">
                    Vupop for Broadcasters
                  </a>
                </li>
                <li className="hover:text-white hover:translate-x-1 transition-all cursor-pointer">
                  <a href="/VupopForBrands" className="block">
                    Vupop for Brands
                  </a>
                </li>
              </ul>
            </div>

            {/* Company Column */}
            <div className="min-w-[120px] lg:min-w-[100px] sm:min-w-0">
              <h4 className="text-white text-[16px] xl:text-[15px] lg:text-[14px] sm:text-[13px] font-semibold mb-6 sm:mb-4">
                Company
              </h4>
              <ul className="space-y-4 sm:space-y-3 text-gray-400 text-[15px] xl:text-[14px] lg:text-[13px] sm:text-[12px]">
                <li className="hover:text-white hover:translate-x-1 transition-all cursor-pointer">
                  <a href="https://vupop.io" className="block">
                    Home
                  </a>
                </li>
                <li className="hover:text-white hover:translate-x-1 transition-all cursor-pointer">
                  <a
                    href="https://manager.vupop.io/broadcaster/signup/subscription"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block"
                  >
                    Pricing
                  </a>
                </li>
                <li
                  className="hover:text-white hover:translate-x-1 transition-all cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/ContactUs");
                  }}
                >
                  Contact Us
                </li>
                <li
                  className="hover:text-white hover:translate-x-1 transition-all cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/referral-program");
                  }}
                >
                  Referral Program
                </li>
                <li className="hover:text-white hover:translate-x-1 transition-all cursor-pointer">
                  <a href="/blogs" className="block">
                    Blogs
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Divider */}
        <div className="border-t border-white/10 mx-8 sm:mx-4"></div>

        {/* Bottom Row */}
        <div
          className="max-w-8xl mx-auto px-8 sm:px-4 py-6
                  flex justify-between items-center
                  md:flex-col md:gap-6"
        >
          <p className="text-[#A6AAB3] text-sm">
            © Vupop 2026. All rights reserved
          </p>

          {/* Social Icons */}
          <div className="flex gap-4">
            <a
              onClick={(e) => {
                e.preventDefault();
                window.open(
                  "https://mail.google.com/mail/?view=cm&fs=1&to=contact@vupop.io",
                  "_blank",
                );
              }}
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 xl:w-9 xl:h-9 
               rounded-full 
               bg-[#1A1D21] 
               flex items-center justify-center 
               hover:bg-[#2a2a2a] 
               transition-colors duration-300"
            >
              <svg
                className="w-5 h-5 xl:w-4 xl:h-4 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <Mail
                  className="text-white 
                   w-6 h-6 
                   md:w-5 md:h-5 
                   sm:w-4 sm:h-4"
                />{" "}
              </svg>
            </a>
            {/* Instagram */}
            <a
              href="https://www.instagram.com/vupop.io/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 xl:w-9 xl:h-9 
               rounded-full 
               bg-[#1A1D21] 
               flex items-center justify-center 
               hover:bg-[#2a2a2a] 
               transition-colors duration-300"
            >
              <svg
                className="w-5 h-5 xl:w-4 xl:h-4 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>

            {/* Facebook */}
            <a
              href="https://www.facebook.com/p/Vupop-61551859059469/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 xl:w-9 xl:h-9 
               rounded-full 
               bg-[#1A1D21] 
               flex items-center justify-center 
               hover:bg-[#2a2a2a] 
               transition-colors duration-300"
            >
              <svg
                className="w-5 h-5 xl:w-4 xl:h-4 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/company/vupop/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 xl:w-9 xl:h-9 
               rounded-full 
               bg-[#1A1D21] 
               flex items-center justify-center 
               hover:bg-[#2a2a2a] 
               transition-colors duration-300"
            >
              <svg
                className="w-5 h-5 xl:w-4 xl:h-4 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452z" />
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
